import { alertCtk, alertCtkApiError } from './shared/utils';
import {
  ajaxLoginUsingCaptcha,
  ajaxLogout,
  checkOkStatusInSuccessFunc,
} from './shared/ajaxutils';
import { urlPathname } from './shared/utils';

import {
  Window,
  FunctionHandler,
  FunctionCallback,
  JsonData,
} from './shared/akatypes';

declare const window: Window;

const jQuery = window.jQuery;

const badPasswordMessage =
  'Zadali jste chybné heslo. Zkuste zadat své heslo znovu. Pokud jste heslo zapomněli, <a href="' +
  window.cnfg_http_aka_tomojectk_base +
  'pass.php?cmd=req">obnovte si ho zde</a>';

function submitLogin(event: Event) {
  console.log('submitting login');

  const data = {
    email: jQuery('#loginemail').val(),
    password: jQuery('#loginpass').val(),
  };

  const jsondata = JSON.stringify(data);
  console.log('jsondata: ' + jsondata);

  const successFunc = (result: string, textStatus: string, jqXHR: any) => {
    if (!checkOkStatusInSuccessFunc(result, textStatus, jqXHR)) {
      return false;
    }
    console.log('login returned');
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const data = { ...parsed };

    if (data.status === 'badpassword') {
      alertCtk(badPasswordMessage);
    } else if (data.status === 'ok') {
      let url = 'index.php';
      if (urlPathname().includes('kosik.php')) {
        url = 'kosik.php';
        console.log('url: ' + url);
        window.location.assign(url);
      } else if (
        urlPathname().includes('index.php') ||
        urlPathname().includes('nakup.php') ||
        urlPathname().includes('kurz.php') ||
        urlPathname().includes('kurzy.php') ||
        urlPathname().includes('lektori.php') ||
        urlPathname().includes('dalsisluzby.php')
      ) {
        window.location.reload();
      } else {
        console.log('url: ' + url);
        window.location.assign(url);
      }
    } else {
      alertCtkApiError();
    }
  };

  ajaxLoginUsingCaptcha(data.email, data, successFunc);

  event.preventDefault();
  return false;
}

export function loggedUserToProfile() {
  console.log('loggedUserToProfile');
  if (jQuery('#logoutid').length) {
    hideOrderForm();
  } else {
    console.log('user not logged - stay here');
  }

  return false;
}

function hideOrderForm() {
  console.log('hideOrderForm');
  jQuery('#orderformvisible').hide();
  jQuery('#orderforminvisible').show();
  return false;
}

export function notLoggedUserToIndex() {
  console.log('notLoggedUserToIndex');
  if (jQuery('#logoutid').length) {
    console.log('logged user - stay here');
  } else {
    const url = 'index.php';
    console.log('user not logged - jump to url: ' + url);
    window.location.assign(url);
  }

  return false;
}

export function loginAndToProfile(email: string, password: string) {
  console.log('loginSilently');

  const data = {
    email: email,
    password: password,
  };

  const jsondata = JSON.stringify(data);
  console.log('jsondata: ' + jsondata);

  const successFunc = (result: string) => {
    console.log('login returned');
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const data = { ...parsed };

    if (data.status === 'badpassword') {
      alertCtk(badPasswordMessage);
    } else if (data.status === 'ok') {
      const url = 'https://www.ctk.cz/mojectk/akaprofile.php';
      console.log('url: ' + url);
      window.location.assign(url);
    } else if (data.status === 'badcaptcha') {
      alertCtk('Chyba reCaptcha - uzivatel je robot?');
    } else {
      alertCtkApiError();
    }
  };
  ajaxLoginUsingCaptcha(data.email, data, successFunc);
  return false;
}

export function logoutUser(event: Event) {
  ajaxLogout(() => {
    window.location.assign('index.php');
  });
  event.preventDefault();
  return false;
}

function loginformSubmitResetPassword(event: Event) {
  // alert(1);
  console.log('submitting loginformSubmitResetPassword');

  const email = jQuery('#loginemail').val();
  const data = {
    email: email,
  };

  const jsondata = JSON.stringify(data);
  console.log('jsondata: ' + jsondata);

  const successFunc = (result: string) => {
    console.log('RequestResetPassword');
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const data = { ...parsed };
    if (data.status === 'userNotFound') {
      alertCtk('Zadaný e-mail pravděpodobně neexistuje');
    } else if (data.status === 'ok') {
      const url =
        window.cnfg_http_aka_tomojectk_base + 'pass.php?email=' + email;
      console.log('url: ' + url);
      window.location.assign(url);
    }
  };
  if (email === undefined || email === '' || !email.includes('@')) {
    const url = window.cnfg_http_aka_tomojectk_base + 'pass.php?cmd=req';
    console.log('url: ' + url);
    window.location.assign(url);
  } else {
    const url =
      window.cnfg_http_aka_tomojectk_base + 'pass.php?cmd=req&email=' + email;
    console.log('url: ' + url);
    window.location.assign(url);
  }

  event.preventDefault();
  return false;
}

export function bindLoginHandler() {
  jQuery('#loginsubmit').on('click', submitLogin);
  jQuery('#akalogoutid').on('click', logoutUser);

  jQuery('#showloginform').on('click', function (e: Event) {
    jQuery('#login-f').show();
    jQuery('#forgottenpass-f').hide();
    jQuery('#register-f').hide();

    jQuery('#showloginform').hide();
    jQuery('#showpassform').show();
    jQuery('#showregisterform').show();

    e.preventDefault();
  });

  jQuery('#showpassform').on('click', loginformSubmitResetPassword);

  jQuery('#login-link').on('click', function () {
    if (!jQuery('#login-form').hasClass('visible')) {
      jQuery('#login-form').addClass('visible');
    } else {
      return false;
    }
  });
  jQuery('#login-link').mouseover(function () {
    jQuery('#login-form').addClass('visible');
  });
  jQuery('#login-link').mouseout(function () {
    if (
      !jQuery('#loginemail').is(':focus') &&
      !jQuery('#loginpass').is(':focus') &&
      !jQuery('#forgottenpassemail').is(':focus') &&
      !jQuery('#registeremail').is(':focus') &&
      !jQuery('#registerpass').is(':focus')
    ) {
      jQuery('#login-form').delay(1000).removeClass('visible');
    }
  });
  jQuery('#login-form').mouseover(function () {
    jQuery('#login-form').addClass('visible');
  });
  jQuery('#login-form').mouseout(function () {
    if (
      !jQuery('#loginemail').is(':focus') &&
      !jQuery('#loginpass').is(':focus') &&
      !jQuery('#forgottenpassemail').is(':focus') &&
      !jQuery('#registeremail').is(':focus') &&
      !jQuery('#registerpass').is(':focus')
    ) {
      jQuery('#login-form').delay(1000).removeClass('visible');
    }
  });

  jQuery('#user-menu-link').mouseover(function () {
    jQuery('#user-menu').addClass('visible');
  });
  jQuery('#user-menu-link').mouseout(function () {
    jQuery('#user-menu').delay(1000).removeClass('visible');
  });
  jQuery('#user-menu').mouseover(function () {
    jQuery('#user-menu').addClass('visible');
  });
  jQuery('#user-menu').mouseout(function () {
    jQuery('#user-menu').delay(1000).removeClass('visible');
  });
}
